import { B1, B2, B3 } from '../../assests/ExportImageIcon'

// Used by pages that fetch real blogs from /admin-panel/blogs/list.
export const formatBlogDate = (value) => {
    if (!value) return ''
    const parsed = new Date(value)
    if (Number.isNaN(parsed.getTime())) return ''
    return parsed.toLocaleDateString('en-US', { day: '2-digit', month: 'long', year: 'numeric' })
}

export const mapBlogItem = (item) => ({
    id: item.id,
    img: item.thumbnail || item.featured_image || B1,
    title: item.title || '',
    author: item.author || item.author_name || 'Sabraah',
    authorImage: item.author_image || null,
    date: formatBlogDate(item.published_at || item.created_at),
})

export const BLOG_POSTS = [
    { img: B1, title: 'Top 10 Hill Stations to Visit This Summer', author: 'finzo', date: '21 April, 2026' },
    { img: B2, title: 'A Traveler\'s Guide to Booking Cheap Flights', author: 'finzo', date: '18 April, 2026' },
    { img: B3, title: 'Best Beaches in Goa You Shouldn\'t Miss', author: 'finzo', date: '15 April, 2026' },
    { img: B1, title: '5 Tips to Plan a Budget-Friendly Trip', author: 'finzo', date: '10 April, 2026' },
    { img: B2, title: 'Why Rishikesh is the Perfect Adventure Getaway', author: 'finzo', date: '05 April, 2026' },
    { img: B3, title: 'How to Choose the Right Travel Insurance', author: 'finzo', date: '01 April, 2026' },
    { img: B1, title: 'A Weekend Guide to Exploring Udaipur', author: 'finzo', date: '28 March, 2026' },
    { img: B2, title: 'Solo Travel Tips for First-Time Backpackers', author: 'finzo', date: '24 March, 2026' },
    { img: B3, title: 'Best Time to Book International Flights', author: 'finzo', date: '20 March, 2026' },
    { img: B1, title: 'Top 5 Cruise Destinations for 2026', author: 'finzo', date: '16 March, 2026' },
    { img: B2, title: 'Packing Hacks Every Frequent Flyer Should Know', author: 'finzo', date: '12 March, 2026' },
    { img: B3, title: 'Exploring the Hidden Gems of Northeast India', author: 'finzo', date: '08 March, 2026' },
    { img: B1, title: 'Family-Friendly Resorts Worth the Splurge', author: 'finzo', date: '04 March, 2026' },
    { img: B2, title: 'Road Trip Essentials for a Car Rental Getaway', author: 'finzo', date: '28 February, 2026' },
    { img: B3, title: 'How to Score the Best Hotel Deals Online', author: 'finzo', date: '24 February, 2026' },
]
